import script from "./backButton.vue?vue&type=script&setup=true&lang=js"
export * from "./backButton.vue?vue&type=script&setup=true&lang=js"

import "./backButton.vue?vue&type=style&index=0&id=46800217&lang=less"

const __exports__ = script;

export default __exports__